// What the engagement's expense tile is made of — the box's other side, beside the jobs
// that bill beyond its price.
//
// One line per job that put cost on the engagement, saying how: a topic's whole cost, or
// the part of a billing job's cost we absorbed. The rest of that job's cost is measured
// against its own charge and is on the jobs' side, so no figure appears on both.
//
// DISPLAY ONLY, and nothing is added up here. The lines and the total are the server's
// (`brokerage.costs`, retainers/topics costSources), and the total is the expense tile's
// own figure — `npm run check:costsources` proves the lines foot to it.
//
// The side is set apart on a soft red panel with a red heading: it is what the engagement
// spent, and the owners read it as the counterweight to the jobs beside it.
import he from '../../i18n/he';
import { Cost } from '../../components/Money';
import DataTable from '../../components/DataTable';

export default function EngagementCosts({ costs, t }) {
  const columns = [
    { key: 'title', label: t.brokerageJob, primary: true, footer: he.common.total },
    {
      key: 'kind',
      label: t.costSource,
      render: (r) => <span className="muted">{r.kind === 'absorbed' ? t.costKindAbsorbed : t.costKindTopic}</span>,
    },
    {
      key: 'amount', label: he.jobs.passThroughCost, className: 'num',
      render: (r) => <Cost value={r.amount} />, footer: <Cost value={costs.total} />,
    },
  ];

  return (
    <div className="w-split-side w-costs">
      <h2>{t.costsTitle}</h2>
      <DataTable columns={columns} rows={costs.lines} />
    </div>
  );
}
